import { render, staticRenderFns } from "./stateProfile.vue?vue&type=template&id=0d1b162a"
import script from "./stateProfile.vue?vue&type=script&lang=js"
export * from "./stateProfile.vue?vue&type=script&lang=js"
import style0 from "./stateProfile.vue?vue&type=style&index=0&id=0d1b162a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports